// extracted by mini-css-extract-plugin
export var bodyRow = "_cv-d";
export var cardColumns = "_cv-e";
export var ellipsesOverflow = "_cv-2";
export var flatBottomCorners = "_cv-3";
export var flatTopCorners = "_cv-4";
export var headerActionsDropdown = "_cv-f";
export var headerBottomRow = "_cv-c";
export var headerTopRow = "_cv-b";
export var orderDetailsWrapper = "_cv-0";
export var orderInfoContainer = "_cv-1";
export var productDetails = "_cv-9";
export var productImage = "_cv-5";
export var responsiveTable = "_cv-8";
export var shipmentContainer = "_cv-a";
export var tableBottomLeft = "_cv-6";
export var tableBottomRight = "_cv-7";
export var trackingLink = "_cv-g";